const listeners = []

export function registerListener(component) {
  listeners.push(component)
}

export function removeListener(component) {
  listeners.splice(listeners.indexOf(component), 1)
}

export function bodyClick(e) {
  listeners.forEach((component) => component.bodyClicked(e))
}

document.addEventListener('mousedown', bodyClick, true)
